import styled from 'styled-components';
import theme from '../../../util/theme';

export const Main = styled.main`
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
  min-height: 100vh;
  width: 100%;
`;

export const Content = styled.div`
  flex-grow: 1;
  max-width: 100%;
  overflow-x: hidden;
  padding-top: 64px;
  padding-bottom: 10px;
  padding-left: 27px;
  padding-right: 27px;
`;

export const TopLine = styled.div`
  height: 3px;
  width: 100%;
  z-index: 1201;
  position: fixed;
  background: ${theme.palette.gradient.light};
`;
